module.exports = __webpack_public_path__ + "img/宣传_120.96bee796.jpg";